import React from 'react'
import { DateRangePicker } from 'react-date-range'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { getDispatchesSummary } from 'client/utils/api-routes-analytics'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcDateRangePicker,
  DcDiv,
  DcFlexBox,
  PixelDiv,
  PixelFactoryContext,
  PixelModal,
  PixelPageContainer,
  PixelText,
  Section,
  SectionActions,
  SectionContent,
  colors,
} from 'pixel-base'

import CardView from './components/CardView'
import { IPixelFactory } from '../../../../../decl'

const breadcrumbs = [
  {
    name: 'Analytics',
    active: false,
  },
  {
    name: 'Dispatches',
    active: true,
  },
]

const Dispatches: React.FC = () => {
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const dispatchRef = React.useRef(null)
  const [showDateModal, setShowDateModal] = React.useState(false)
  const [filters, setFilters] = React.useState({
    start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    data_type: 'monthly',
  })

  const [data, setData] = React.useState<any[]>([])
  const getReportSummary = () => {
    showLoader(dispatchRef)
    getDispatchesSummary(filters).subscribe((res: any) => {
      hideLoader(dispatchRef)
      setData(res.response.data || [])
    })
  }
  React.useEffect(() => {
    getReportSummary()
  }, [])
  return (
    <DcFlexBox flexDirection="column">
      <DcFlexBox
        padding="0px 20px"
        height="60px"
        style={{
          justifyContent: 'space-between',
          borderBottom: `1px solid ${colors.grayBorderLight}`,
        }}
        alignItems="center"
      >
        <DcFlexBox alignItems="center" width="auto">
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
          <SectionActions />
        </DcFlexBox>
        <DcDiv>
          <ProfileSection />
        </DcDiv>
      </DcFlexBox>
      <PixelPageContainer padding="0px">
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '5px 20px', borderRadius: '0px' }}>
            <DcDateRangePicker
              size="sm"
              month={2}
              ranges={filters}
              onApply={() => {
                getReportSummary()
              }}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  start_date: moment(e.range1.startDate).format('YYYY-MM-DD'),
                  end_date: moment(e.range1.endDate).format('YYYY-MM-DD'),
                })
              }}
            />
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          {/* <SectionActions
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '10px',
              gap: '10px',
              height: '40px',
            }}
          > */}
          {/* <PixelButton
              variant="outline"
              onClick={() => setShowDateModal(true)}
            >
              Date&nbsp;&nbsp;
              {filters.start_date &&
              filters.end_date &&
              moment(filters.start_date).format('ll') ===
                moment().subtract(30, 'days').format('ll') &&
              moment(filters.end_date).format('ll') ===
                moment().format('ll') ? (
                  <PixelText style={{ color: colors.black }}>Last 30 Days</PixelText>
              ) : (
                <PixelText style={{ color: colors.black }}>
                  {moment(filters.start_date).format('ll')}
                  {'  >  '}
                  {moment(filters.end_date).format('ll')}
                </PixelText>
              )}
            </PixelButton>
            <PixelButton
              onClick={() => {
                getReportSummary()
              }}
            >
              Update
            </PixelButton> */}
          {/* </SectionActions> */}
          {data.length !== 0 ? (
            <SectionContent ref={dispatchRef}>
              <PixelDiv
                style={{ height: 'calc(100vh - 161px)', overflow: 'auto' }}
              >
                <div>
                  <CardView color={$DCprimaryColor} data={data} />
                </div>
              </PixelDiv>
            </SectionContent>
          ) : (
            <SectionContent>
              <PixelText>There is no record found</PixelText>
            </SectionContent>
          )}
        </Section>
      </PixelPageContainer>
      {showDateModal && (
        <PixelModal
          title={''}
          size={{
            width: '950px !important',
            maxWidth: '100% !important',
          }}
          handleClose={() => setShowDateModal(false)}
          show={showDateModal}
        >
          <PixelDiv style={{ overflow: 'auto' }}>
            <DateRangePicker
              rangeColors={[$DCprimaryColor]}
              onChange={(item) => {
                if (
                  moment(item.selection.startDate).format('MM-DD-YYYY') !==
                  moment(item.selection.endDate).format('MM-DD-YYYY')
                ) {
                  setShowDateModal(false)
                } else if (
                  item.selection.startDate === '' &&
                  item.selection.endDate === ''
                ) {
                  setShowDateModal(false)
                }
                setFilters({
                  ...filters,
                  start_date: moment(item.selection.startDate).format(
                    'YYYY-MM-DD',
                  ),
                  end_date: moment(item.selection.endDate).format('YYYY-MM-DD'),
                })
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={[
                {
                  startDate: new Date(filters.start_date),
                  endDate: new Date(filters.end_date),
                  key: 'selection',
                },
              ]}
              direction="horizontal"
            />
          </PixelDiv>
        </PixelModal>
      )}
    </DcFlexBox>
  )
}
export default Dispatches
